import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { ChatMessage } from './ChatMessage';
import { TypingIndicator } from './TypingIndicator';
import { type ChatMessageType, type MessageSender } from '../model/chatTypes';

interface ChatMessageListProps {
  messages: ChatMessageType[];
  isTyping: boolean;
  typingSender: MessageSender;
}

export const ChatMessageList: React.FC<ChatMessageListProps> = observer(({ messages, isTyping, typingSender }) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length, isTyping]);

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        py: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {messages.map((msg) => (
        <ChatMessage key={msg.id} message={msg} />
      ))}
      {isTyping && <TypingIndicator sender={typingSender} />}
      <div ref={bottomRef} />
    </Box>
  );
});
